import { useTracking } from 'react-tracking';
import { ROUTE_PLANS } from '@/constants/routes';
import { useUserAccess } from '@/hooks/useUserAccess';
import { useTranslation } from '@/hooks/useTranslation';
import useUser from '@/hooks/useUser';
import { Button } from '@simplywallst/ui-core/next';
import { getPath } from '@/router/utils';

export const UpgradeButton = () => {
  const { trackEvent } = useTracking({
    type: 'track',
    subject: 'desktopTopBarUpgrade',
  });
  const t = useTranslation();

  const user = useUser();
  const userAccess = useUserAccess();

  const showUpgradeButton =
    RUNTIME_ENV !== 'native' &&
    userAccess.data.planType === 'free' &&
    userAccess.data.provider === 'stripe' &&
    user.data.billing.status !== 'trialing';

  if (!showUpgradeButton) return;

  return (
    <Button
      href={getPath({ type: ROUTE_PLANS, payload: {} })}
      size="medium"
      className="self-center"
      data-cy-id="nav-upgrade-btn-desktop"
      onClick={() => {
        trackEvent({ action: 'click' });
      }}
    >
      {t('app.topbar.nav.upgrade')}
    </Button>
  );
};
